/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2024 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
/* eslint-disable max-len */

/**
 * QRCodeErrorIcon icon
 *
 * @file QRCodeErrorIcon.jsx
 * @author Anuja Gaikwad
 * @since 0.0.1
 */


import React from 'react';
import { styled } from '@mui/material/styles';

const IconWrapper = styled('div')({
  '&&': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 12,
    borderRadius: '50%',
    backgroundColor: '#EFEDFF'
  }
});

const SvgIconStyled = styled('svg')({
  '&&': {
    width: 40,
    height: 40
  }
});

const QRCodeErrorIcon = () => (
  <IconWrapper>
    <SvgIconStyled
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M28.52 17.284C30.496 17.284 32.104 15.676 32.104 13.7V11.816C32.104 11.484 31.836 11.216 31.504 11.216C31.172 11.216 30.904 11.484 30.904 11.816V13.7C30.904 15.016 29.836 16.084 28.52 16.084H27.224C27.104 14.668 26.14 13.492 24.836 13.06V12.368C24.836 10.812 23.844 9.484 22.464 8.976C23.076 8.368 23.456 7.528 23.456 6.6C23.456 6.268 23.188 6 22.856 6C22.524 6 22.256 6.268 22.256 6.6C22.256 7.784 21.292 8.748 20.108 8.748C18.924 8.748 17.96 7.784 17.96 6.6C17.96 6.268 17.692 6 17.36 6C17.028 6 16.76 6.268 16.76 6.6C16.76 7.528 17.14 8.368 17.752 8.976C16.368 9.484 15.38 10.812 15.38 12.368V13C13.972 13.372 12.912 14.596 12.788 16.084H11.556C10.204 16.084 9.10399 14.984 9.10399 13.632V11.816C9.10399 11.484 8.83599 11.216 8.50399 11.216C8.17199 11.216 7.90399 11.484 7.90399 11.816V13.632C7.90399 15.644 9.53999 17.284 11.556 17.284H12.772V21.656H8.50399C8.17199 21.656 7.90399 21.924 7.90399 22.256C7.90399 22.588 8.17199 22.856 8.50399 22.856H12.772V26.668C12.772 26.856 12.788 27.044 12.8 27.228H11.488C9.51199 27.228 7.90399 28.836 7.90399 30.812V32.696C7.90399 33.028 8.17199 33.296 8.50399 33.296C8.83599 33.296 9.10399 33.028 9.10399 32.696V30.812C9.10399 29.496 10.172 28.428 11.488 28.428H12.992C13.756 31.52 16.484 33.836 19.772 33.988C19.816 34 19.86 34.004 19.908 34.004C19.94 34.004 19.972 34 20.008 34C20.04 34 20.072 34.004 20.108 34.004C20.156 34.004 20.2 33.996 20.244 33.988C23.532 33.84 26.256 31.52 27.024 28.428H28.464C29.816 28.428 30.916 29.528 30.916 30.88V32.696C30.916 33.028 31.184 33.296 31.516 33.296C31.848 33.296 32.116 33.028 32.116 32.696V30.88C32.116 28.868 30.48 27.228 28.464 27.228H27.22C27.236 27.044 27.248 26.856 27.248 26.668V22.856H31.516C31.848 22.856 32.116 22.588 32.116 22.256C32.116 21.924 31.848 21.656 31.516 21.656H27.248V17.284H28.532H28.52ZM20.7 32.744V22.168C20.7 21.836 20.432 21.568 20.1 21.568C19.768 21.568 19.5 21.836 19.5 22.168V32.772C16.396 32.468 13.964 29.848 13.964 26.664V16.376C13.964 15.424 14.544 14.604 15.372 14.256V15.424C15.372 15.756 15.64 16.024 15.972 16.024H24.236C24.568 16.024 24.836 15.756 24.836 15.424V14.352C25.552 14.744 26.04 15.504 26.04 16.372V26.66C26.04 29.772 23.708 32.344 20.704 32.736L20.7 32.744Z"
        fill="#512EAB"
      />
    </SvgIconStyled>
  </IconWrapper>
);


export default QRCodeErrorIcon;
